import { useClientConfiguration } from "../data/global/useProductConfiguration";

const useHideCompStatusColumnsAsFrm = (client: string, isFrm: boolean) => {
  const config = useClientConfiguration(client);
  return config.hideCompStatusColumnsAsFrm && isFrm;
};

export default useHideCompStatusColumnsAsFrm;
